import { IOSSwitch } from '@adotel/components'
import { Button, MenuItem, Select, Typography } from '@material-ui/core'

import {
  getCurrenciesAvailable,
  isFaAvailableInLanguages
} from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { Currency } from '../../types/currency'
import { GetInventoryInput } from '../../types/inventory'
import InventorySecondaryFiltersTrigger from './InventorySecondaryFiltersTrigger'
import useStyles from './styles/InventoryTableOptions.styles'

interface InventoryTableOptionsProps {
  secondaryFilterIsOpen: boolean
  setsecondaryFilterIsOpen: (value: boolean) => void
  occupancy: number | 'def'
  setOccupancy: (v: number | 'def') => void
  hideZeroes: boolean
  sethideZeroes: (v: boolean) => void
  isRangeMonth: boolean
  refreshInventory: () => void
  getInventoryInput: GetInventoryInput
  setgetInventoryInput: React.Dispatch<React.SetStateAction<GetInventoryInput>>
}

const InventoryTableOptions: React.FC<InventoryTableOptionsProps> = ({
  secondaryFilterIsOpen,
  setsecondaryFilterIsOpen,
  hideZeroes,
  sethideZeroes,
  occupancy,
  setOccupancy,
  isRangeMonth,
  refreshInventory,
  getInventoryInput,
  setgetInventoryInput
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.rightSide}>
        {/* <div>
          <Button
            disabled={updateDisabled}
            variant="contained"
            onClick={() => updateInventory()}>
            {getTranslate('Update')}
          </Button>
        </div> */}
        <div className={classes.refreshButton}>
          <Button variant="contained" onClick={() => refreshInventory()}>
            {getTranslate('Refresh')}
          </Button>
        </div>
        <InventorySecondaryFiltersTrigger
          isOpen={secondaryFilterIsOpen}
          setIsOpen={setsecondaryFilterIsOpen}
        />
      </div>
      <div>
        {isFaAvailableInLanguages() && (
          <div className={classes.hideZerosFromPriceContainer}>
            <Typography>{getTranslate('Hide 0.000 From Prices')}</Typography>
            <IOSSwitch
              color="primary"
              disabled={isRangeMonth}
              checked={hideZeroes}
              onChange={(e) => {
                sethideZeroes(e.target.checked)
              }}
            />
          </div>
        )}
        <div className={classes.occupancyContainer}>
          <Typography>{getTranslate('Occupancy')}:</Typography>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={occupancy}
            onChange={(event) => {
              setOccupancy(event.target.value as number | 'def')
            }}>
            <MenuItem value={'def'}>{getTranslate('def')}</MenuItem>
            {Array(7)
              .fill('')
              .map((_, index) => (
                <MenuItem key={index} value={index + 1}>
                  {index + 1}
                </MenuItem>
              ))}
          </Select>
          <div className={classes.currencyContainer}>
            <Typography>{getTranslate('Currency')}:</Typography>
            <Select
              value={getInventoryInput.Currency}
              onChange={(event) => {
                setgetInventoryInput({
                  ...getInventoryInput,
                  Currency: event.target.value as Currency
                })
              }}>
              {getCurrenciesAvailable().map((currency) => (
                <MenuItem
                  key={currency}
                  value={currency}
                  className={classes.menuItemRight}>
                  {getTranslate(currency || '')}
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InventoryTableOptions
